import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-49",
  "use": "icon-sheet_icon-49-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-49\"><g transform=\"translate(-266 -146)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><rect x=\"269.75\" y=\"148.75\" width=\"16.5\" height=\"18.5\" rx=\"2\" /><rect x=\"272.75\" y=\"151.75\" width=\"10.5\" height=\"4.5\" rx=\"1\" /><path stroke-linecap=\"round\" d=\"M272.778 159.668h10.41M272.778 163.285h6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol